import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { ListaRelatorioResponse } from '../../../shared/services/responses/relatorio-interno/lista-relatorio.response';
import { ListaPerfilResponse } from '../../../shared/services/responses/usuario-admin/lista-perfil.response';
import { ListaPerfilStruct } from '../../../shared/services/structs/usuario-admin/lista-perfil.struct';
import { MatOption } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { RelatorioPerfilRequest } from '../../../shared/services/requests/relatorio-interno/relatorio-rerfil.request';
import { UsuarioAdminLookupResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin-lookup.response';
import { UsuarioAdminService } from '../../../shared/services/apis/usuario-admin/usuario-admin.service';
import { UsuarioAdminResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin.response';
import { UsuarioAdminLoginResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin-login.response';
import { IframeModalComponent } from '../../../shared/components/iframe-modal/iframe-modal.component';
import { MeusRelatoriosService } from '../../../shared/services/apis/relatorio-interno/meus-relatorios.service';
import { PerfilEnum } from '../../../shared/enums/perfil.enum';
import { RelatorioNomePerfilStruct } from '../../../shared/services/structs/relatorio-interno/relatorio-nome-perfil.strcut';
import { NomePerfilPipe } from '../../../shared/pipes/nome-perfil.pipe';
import { Perfil } from '../../../shared/services/models/usuario-admin/perfil.model';

@Component({
  selector: 'app-meus-relatorios',
  imports: [
    MenuComponent,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    ReactiveFormsModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatOption,
    MatSelectModule,
    FormsModule,
    NomePerfilPipe,
  ],
  templateUrl: './meus-relatorios.component.html',
  styleUrl: './meus-relatorios.component.css',
})
export class MeusRelatoriosComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private meusRelatoriosService: MeusRelatoriosService,
    private usuarioAdminService: UsuarioAdminService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.moduloEnum = ModuloEnum.InteligenciaDados;
    this.funcionalidadeEnum = FuncionalidadeEnum.InteligenciaDados_MeusRelatorios;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaRelatorioResponse: ListaRelatorioResponse | undefined;
  public _listaPerfilStruct: ListaPerfilResponse | undefined;
  public _listaRelatorioNomePerfil: RelatorioNomePerfilStruct[];
  public _usuarioLookupResponse: UsuarioAdminLookupResponse;
  public displayedColumns: string[] = ['idRelatorio', 'tituloRelatorio', 'perfilAcesso', 'action-view'];
  public _dataSource = new MatTableDataSource<RelatorioPerfilRequest>();
  public _dataSourcePerfil = new MatTableDataSource<ListaPerfilStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _perfilSelect: FormControl = new FormControl('');
  public _perfilSelectOptions: ListaPerfilStruct[] = [];
  public _listaIdPerfilPermissao: number[] = [];
  public _temPermissaoMeusRelatorios: boolean = false;
  public _enumPerfil = PerfilEnum;
  public modalVisualizarAberto: { link: string; aberto: boolean; titulo: string } = {
    link: '',
    aberto: false,
    titulo: '',
  };

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      tituloRelatorio: [''],
      perfilAcesso: [''],
    });

    this.popularDadosUsuario();
  }

  popularDadosUsuario(): void {
    const objToken = sessionStorage.getItem('token');
    if (!objToken) return;

    const token: UsuarioAdminLoginResponse = JSON.parse(objToken);
    if (!token) return;

    this.usuarioAdminService.ObterPorId(token.idUsuarioAdmin).subscribe({
      next: (usuarioResponse: UsuarioAdminResponse) => {
        if (usuarioResponse.isError) {
          this.alertService.show('Erro', usuarioResponse.errorDescription, AlertType.error);
          return;
        }

        this.popularLookup(usuarioResponse.listaIdPerfil);
        this.pesquisar(usuarioResponse.listaIdPerfil);
        this._listaIdPerfilPermissao = usuarioResponse.listaIdPerfil;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  popularLookup(listaIdPerfil: number[]): void {
    this.usuarioAdminService.Lookup().subscribe({
      next: (usuarioLookupResponse: UsuarioAdminLookupResponse) => {
        if (usuarioLookupResponse.isError) {
          this.alertService.show('Erro', usuarioLookupResponse.errorDescription, AlertType.error);
          return;
        }

        this._usuarioLookupResponse = {
          ...usuarioLookupResponse,
          listaPerfil: usuarioLookupResponse.listaPerfil.filter(perfil =>
            listaIdPerfil.includes(perfil.idPerfil)
          ),
        };
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  pesquisar(listaIdPerfil: number[]): void {
    if (this.model.invalid || this._isLoading) {
      return;
    }

    this._isLoading = true;
    const titulo: string = this.model.get('tituloRelatorio')?.value.trim() ?? '';
    const perfilAcessoPesquisar: number[] = listaIdPerfil?.length
      ? listaIdPerfil
      : this._listaIdPerfilPermissao;

    this.meusRelatoriosService.get(titulo, perfilAcessoPesquisar.toString(), this._paginaAtual).subscribe({
      next: (relatorioResponse: ListaRelatorioResponse) => {
        if (relatorioResponse.isError) {
          this.alertService.show('Erro', relatorioResponse.errorDescription, AlertType.error);
          return;
        }

        this._isLoading = false;
        this._ultimaPagina = true;

        if (!this._listaRelatorioResponse) {
          this._listaRelatorioResponse = relatorioResponse;
          this._ultimaPagina = false;
        } else if (relatorioResponse.listaRelatorioPerfil?.length > 0) {
          this._listaRelatorioResponse.listaRelatorioPerfil.push(...relatorioResponse.listaRelatorioPerfil);
          this._ultimaPagina = false;
        }

        this._dataSource.data = this._listaRelatorioResponse.listaRelatorioPerfil;
        this._listaRelatorioNomePerfil = this._listaRelatorioResponse.listaRelatorioPerfil.map(
          relatorioPerfil => {
            let perfis: Perfil[] = [];
            if (this._usuarioLookupResponse && this._usuarioLookupResponse.listaPerfil) {
              perfis = this._usuarioLookupResponse.listaPerfil.filter(perfil =>
                relatorioPerfil.listaIdPerfil.includes(perfil.idPerfil)
              );
            }

            return {
              idRelatorioPerfil: relatorioPerfil.idRelatorioPerfil,
              relatorio: relatorioPerfil.relatorio,
              listaPerfil: perfis,
              listaIdPerfil: relatorioPerfil.listaIdPerfil,
            } as RelatorioNomePerfilStruct;
          }
        );
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaRelatorioResponse = undefined;
    this.pesquisar(this.model.get('perfilAcesso')?.value);
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar(this.model.get('perfilAcesso')?.value);
  }

  abrirIframeModal(linkRelatorio: string, tituloRelatorio: string): void {
    this.dialog.open(IframeModalComponent, {
      width: '100%',
      maxWidth: 'calc(100dvw - 50px)',
      height: '100%',
      maxHeight: 'calc(100dvh - 80px)',
      panelClass: 'custom-dialog-container',
      data: { linkRelatorio: linkRelatorio, tituloRelatorio: tituloRelatorio },
    });
  }
}
